import React, { useState } from 'react'
import buyerRoutes from '../../common/buyerRoutes';
import { withRouter } from 'react-router';
import './TopNavigationBarNew.less';
import businessProActive from '../../assets/images/newui/navbar/business-pro-active.svg'
import businessPro from '../../assets/images/newui/navbar/business-pro.svg'
import businessProActive_new from '../../assets/images/newui/navbarNew/business-pro-active.svg'
import businessPro_new from '../../assets/images/newui/navbarNew/business-pro.svg'

import Config from 'Config'
import { connect } from 'react-redux';


const TopNavigationBarNew = ({ history, currentUser, closeNavMenu }) => {
    const [hoveredElem, setHoveredElem] = useState({});
    const businessProfileNav = {
        name: "Business Profile",
        img: businessPro,
        activeImg: businessProActive,
        imgNew: businessPro_new,
        activeImgNew: businessProActive_new
    }
    let tabs = buyerRoutes.filter(br => br.imgNew);
    const activeTab = tabs.find(tab => tab.path && tab.path.includes(history.location.pathname.split('/')[1])) || {}
    const onClick = (tab) => {
        const { state, city, seoName } = currentUser.Seller;
        if (tab.name == "Business Profile") {
            window.open(`${Config.badr.url}/business/${state}/${city}/${seoName}`, "_blank");
            return;
        }
        closeNavMenu();
        history.push(tab.path);
    }
    if (currentUser.Seller.isProfilePublished) {
        tabs = [...tabs, businessProfileNav]
    }
    return (
        <div className={"outer-wrapper-container"}>
            <div className={"top-arrow-icon-container"}>
                <svg xmlns="http://www.w3.org/2000/svg" width="15.531" height="7.735" viewBox="0 0 15.531 7.735">
                    <path id="Path_41834" data-name="Path 41834" d="M452.3,177.5l-7.766,7.735-7.766-7.735Z" transform="translate(452.296 185.233) rotate(180)" fill="#d3d3d3" />
                </svg>
            </div>
            <div className='top-nav-bar-new-container' /*style={{ width: `${134 * tabs.length}px` }}*/>
                {tabs.map((tab, tabIndex) => <div
                    onMouseOver={() => setHoveredElem(tab)}
                    onMouseOut={() => setHoveredElem({})}
                    onClick={() => onClick(tab)}
                    className={`top-nav-bar-new-tab${activeTab.name == tab.name || hoveredElem.name == tab.name ? ' active' : ''} ${tabIndex % 2 == 0 ? " even" : " odd"}`}>

                    <img src={activeTab.name == tab.name || hoveredElem.name == tab.name ? tab.activeImgNew : tab.imgNew} />
                    <div className='top-nav-bar-tab-content'> {tab.name}</div>
                </div>)}
            </div>
        </div>

    )



}
const mapStateToProps = ({
    auth: { currentUser },
}) => {
    return { currentUser };
}

export default withRouter(connect(mapStateToProps, null)(TopNavigationBarNew));